const uncheckHTML = `
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <g filter="url(#filter0_i_247_586)">
    <path d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z" fill="url(#paint0_linear_247_586)"></path>
  </g>
  <g filter="url(#filter1_i_247_586)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16 1H4C2.34315 1 1 2.34315 1 4V16C1 17.6569 2.34315 19 4 19H16C17.6569 19 19 17.6569 19 16V4C19 2.34315 17.6569 1 16 1ZM4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4Z" fill="url(#paint1_linear_247_586)"></path>
  </g>
  <defs>
    <filter id="filter0_i_247_586" x="0" y="0" width="21" height="21" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
      <feOffset dx="1" dy="1"></feOffset>
      <feGaussianBlur stdDeviation="1"></feGaussianBlur>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_247_586"></feBlend>
    </filter>
    <filter id="filter1_i_247_586" x="0" y="0" width="21" height="21" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
      <feOffset dx="1" dy="1"></feOffset>
      <feGaussianBlur stdDeviation="1"></feGaussianBlur>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_247_586"></feBlend>
    </filter>
    <linearGradient id="paint0_linear_247_586" x1="10" y1="0" x2="10" y2="20" gradientUnits="userSpaceOnUse">
      <stop stop-color="#E8E8E8"></stop>
      <stop offset="1" stop-color="#F7F7F7"></stop>
    </linearGradient>
    <linearGradient id="paint1_linear_247_586" x1="10" y1="0" x2="10" y2="20" gradientUnits="userSpaceOnUse">
      <stop stop-color="#9C9C9C"></stop>
      <stop offset="1" stop-color="#5D5D5D"></stop>
    </linearGradient>
  </defs>
</svg>`;

const checkHTML = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z" fill="#0075FF"/>
  <g filter="url(#filter0_d_247_683)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7413 6.25831C15.3963 5.9139 14.8371 5.9139 14.4921 6.25831L8.85802 11.8838L5.50785 8.53877C5.16291 8.19436 4.60365 8.19436 4.25871 8.53877C3.91376 8.88319 3.91376 9.44159 4.25871 9.786L8.00613 13.5277C8.05746 13.5789 8.11353 13.6226 8.17293 13.6586C8.19539 13.6874 8.2199 13.7152 8.24644 13.7417C8.59138 14.0861 9.15064 14.0861 9.49558 13.7417L15.7413 7.50554C16.0862 7.16113 16.0862 6.60272 15.7413 6.25831Z" fill="white"/>
  </g>
  <defs>
    <filter id="filter0_d_247_683" x="3.8" y="5.8" width="13.2" height="9.2" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="0.4" dy="0.4"/>
      <feGaussianBlur stdDeviation="0.3"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_247_683"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_247_683" result="shape"/>
    </filter>
  </defs>
</svg>`;

fetch('https://static.rechargecdn.com/store/8sheep.myshopify.com/product/2020-12/products.json')
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    console.log('good response', data);
    const sellingPlanHtml = {};
    data.products.forEach(product => {
      const productInfo = Object.values(product)[0];
      const productId = Object.keys(product)[0];
      sellingPlanHtml[productId] = '';
      if (!productInfo.selling_plan_groups[0]) {
        return;
      }
      productInfo.selling_plan_groups[0].selling_plans.forEach(plan => {
        sellingPlanHtml[productId] += `<option value="${plan.selling_plan_id}">${plan.selling_plan_name}</option>`;
      })
    });

    let rebuyDomCheck;
    const doRebuyDomCheck = function () {
      let element = document.querySelector('ul.rebuy-cart__flyout-items');
      if (element) {
        const lists = element.querySelectorAll('li');
        const cartItems = Rebuy.Cart.items();
        cartItems.forEach((item, i) => {
          if (sellingPlanHtml[cartItems[i].product.id] && !lists[i].classList.contains('flag')) {
            const key = cartItems[i].key;
            const list = lists[i];
            list.classList.add('flag');
            const container = document.createElement('div');
            container.classList.add('cart-upgrade-subscription');
            const checkMark = document.createElement('span');
            checkMark.setAttribute('role', 'checkbox');
            checkMark.setAttribute('tabindex', '0');
            checkMark.setAttribute('aria-labelledby', 'subscribe-save-10');
            checkMark.setAttribute('aria-checked', 'false');
            checkMark.innerHTML = uncheckHTML;
            const label = document.createElement('span');
            label.setAttribute('id', 'subscribe-save-10');
            label.classList.add('label');
            label.innerText = 'Subscribe & save 10%';
            const select = document.createElement('select');
            select.id = 'select-save-10';
            select.innerHTML = sellingPlanHtml[cartItems[i].product.id];
            container.appendChild(checkMark);
            container.appendChild(label);
            container.appendChild(select);

            select.style.display = 'none';
            if (!Rebuy.Cart.itemIsOneTime(item)) {
              select.style.display = 'block';
              checkMark.setAttribute('aria-checked', 'true');
              checkMark.innerHTML = checkHTML;
              select.value = item.selling_plan_allocation.selling_plan.id;
            }
            checkMark.addEventListener('click', () => {
              const cartItem = Rebuy.Cart.items().filter(item => item.key === key)[0];
              const lineId = Rebuy.Cart.items().findIndex(item => item === cartItem);
              const data = {
                "line": lineId + 1,
                "quantity": cartItem.quantity,
                "selling_plan": parseInt(select.value)
              };

              if (select.style.display === 'none') {
                select.style.display = 'block';
                checkMark.innerHTML = checkHTML;
                checkMark.setAttribute('aria-checked', 'true');
              } else {
                select.style.display = 'none';
                checkMark.innerHTML = uncheckHTML;
                checkMark.setAttribute('aria-checked', 'false');
                data.selling_plan = null;
              }
              fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
              });
            });

            checkMark.addEventListener('keydown', (e) => {
              if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                checkMark.click();
              }
            });

            select.addEventListener('change', e => {
              const cartItem = Rebuy.Cart.items().filter(item => item.key === key)[0];
              const lineId = Rebuy.Cart.items().findIndex(item => item === cartItem);
              const data = {
                "line": lineId + 1,
                "quantity": cartItem.quantity,
                "selling_plan": parseInt(e.target.value)
              };
              fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
              });
            });
            list.appendChild(container);
          }
        });
      }
    };
    rebuyDomCheck = setInterval(doRebuyDomCheck, 200);
  })
  .catch(error => {
    console.error('Error fetching data:', error);
  });